
import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../../Context/AuthContext.jsx";

const DailyRedeemption = ({ activeTab }) => {
  const { token } = useAuth();
  const [pointrule, setPointrule] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [redeempoint, setRedeempoint] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [copiedEmail, setCopiedEmail] = useState("");

  const currentRules = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/pointrule/currentcap`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.status === 200) {
        setPointrule(response.data.pointRule);
      }
    } catch (error) {
      console.error("Error fetching current rules:", error);
    }
  }, [token]);

  useEffect(() => {
    if (activeTab === 10) {
      currentRules();
    }
  }, [activeTab, currentRules]);

  const toggleShowMore = () => {
    setShowAll((prev) => !prev);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/pointrule/updatecap`,
        { "dailyreedemPoints": parseInt(redeempoint) },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (response.status === 200) {
        setMessage(response.data.message)
        currentRules();
        setTimeout(() => {
          setMessage("");
          setRedeempoint('')
          setShowConfigModal(false);
        }, 2000)
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopyEmail = (email) => {
    if (!email) return;
    navigator.clipboard.writeText(email);
    setCopiedEmail(email);
    setTimeout(() => setCopiedEmail(""), 2000);
  };

  if (activeTab !== 10) return null;

  const history = pointrule?.last_updated_by || [];
  const displayHistory = showAll ? [...history].reverse() : [history[history.length - 1]];

  return (
    <div className="animate-fadeIn pb-12 space-y-10">

      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
        <div className="flex items-center gap-4">

          <div className="flex flex-col items-start">
            <h2 className="text-2xl font-bold text-gray-900 tracking-tight">Redemption Policies</h2>
            <p className="text-sm text-gray-500 font-medium ">Configure daily point limits and global caps.</p>
          </div>
        </div>

        <button
          onClick={() => setShowConfigModal(true)}
          className="px-6 py-3 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-xl font-semibold text-sm transition-all flex items-center gap-2"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Update System Cap
        </button>
      </div>

      {/* Info Badge & Stats Grid */}
      <div className="space-y-6">
        <div className="bg-amber-50 border border-amber-100 rounded-xl p-4 flex items-center gap-4 group">
          <div className="h-10 w-10 bg-white rounded-xl shadow-sm flex items-center justify-center text-amber-500">
            <svg className="w-6 h-6 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div className="flex flex-col items-start">
            <p className="text-xs font-medium text-amber-600 leading-none">Global Implementation</p>
            <p className="text-xs font-medium text-amber-900 mt-1">Updates take effect daily at <span className="underline decoration-2 underline-offset-2">12:00 AM IST</span></p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm relative overflow-hidden group">
            {/* <div className="absolute top-0 right-0 p-8 opacity-5 transform translate-x-4 -translate-y-4">
              <svg className="w-24 h-24 text-[#004f6b]" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>
            </div> */}
            <div className="relative z-10 flex flex-col items-center justify-between h-full">
              <p className="text-xs font-medium text-gray-400 mb-2">Currently Running</p>
              <div className="flex items-end gap-3">
                <span className="text-5xl font-bold text-[#004f6b] tracking-tight">{pointrule?.capvalue || '0'}</span>
                <span className="text-sm font-medium text-gray-400 mb-2">Points/Day</span>
              </div>
              <div className="mt-6 flex items-center gap-2">
                <div className="px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium border border-green-100">Live Strategy</div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl p-8 border border-gray-100 shadow-sm relative overflow-hidden group">
            {/* <div className="absolute top-0 right-0 p-8 opacity-5 transform translate-x-4 -translate-y-4">
              <svg className="w-24 h-24 text-amber-500" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" /></svg>
            </div> */}
            <div className="relative z-10 flex flex-col items-center justify-between h-full">
              <p className="text-xs font-medium text-gray-400 mb-2">Queue (Next Cycle)</p>
              <div className="flex items-end gap-3">
                <span className="text-5xl font-bold text-amber-500 tracking-tight">{pointrule?.pendingcapvalue || '0'}</span>
                <span className="text-sm font-medium text-gray-400 mb-2">Pending</span>
              </div>
              <div className="mt-6 flex items-center gap-2">
                <div className="px-3 py-1 bg-amber-50 text-amber-600 rounded-full text-xs font-medium border border-amber-100">Synchronizing...</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* History Table */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="px-8 py-5 border-b border-gray-100 bg-gray-50/50 flex justify-between items-center">
          <h3 className="text-base font-semibold text-gray-800">Modification Log</h3>
          <button
            onClick={toggleShowMore}
            className="text-xs font-medium text-[#004f6b] hover:underline px-4"
          >
            {showAll ? 'Collapse' : 'View Full History'}
          </button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left">
            <thead>
              <tr className="bg-gray-50  border-b border-gray-50">
                <th className="px-8 py-4 text-xs font-medium text-gray-600 text-center">ID</th>
                <th className="px-8 py-4 text-xs font-medium text-gray-600">Email</th>
                <th className="px-8 py-4 text-xs font-medium text-gray-600"> Cap Points</th>
                <th className="px-8 py-4 text-xs font-medium text-gray-600">Timestamp</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {history.length > 0 ? (
                displayHistory.map((entry, index) => (
                  <tr key={index} className="group hover:bg-gray-50/50 transition-colors">
                    <td className="px-8 py-5 text-sm text-gray-300 font-mono text-center">#{entry.id || (history.length - index)}</td>
                    <td className="px-8 py-5">
                      <div className="flex items-center gap-3">
                        <div className="h-8 w-8 rounded-full bg-gray-50 border border-gray-100 flex items-center justify-center text-[#004f6b] text-xs font-semibold uppercase">
                          {entry.email?.charAt(0)}
                        </div>
                        <span
                          className="text-sm font-medium text-gray-800 hover:text-[#004f6b] cursor-pointer transition-colors flex items-center gap-1 group/email"
                          onClick={() => handleCopyEmail(entry.email)}
                          title="Click to copy"
                        >
                          {entry.email || "N/A"}
                          <svg className={`w-3 h-3 opacity-0 group-hover/email:opacity-100 transition-opacity ${copiedEmail === entry.email ? 'text-green-500 opacity-100' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            {copiedEmail === entry.email ? (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            ) : (
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                            )}
                          </svg>
                        </span>
                      </div>
                    </td>
                    <td className="px-8 py-5 text-sm font-semibold text-gray-800">{entry.capvalue || "N/A"} Pts</td>
                    <td className="px-8 py-5 text-xs text-gray-400 font-medium">
                      {entry.timestamp ? new Date(entry.timestamp).toLocaleString('en-IN') : "N/A"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="px-8 py-10 text-center text-gray-400 font-medium italic">No historical audit data available.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Configurator Modal */}
      {showConfigModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm animate-fadeIn"
            onClick={() => !isSubmitting && setShowConfigModal(false)}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-white rounded-xl shadow-xl w-full max-w-2xl animate-zoomIn border border-gray-100 overflow-hidden">
            <div className="p-8 border-b border-gray-100 bg-gray-50/50 text-center relative">
              <h3 className="text-xl text-start font-bold text-gray-900">Adjust Daily System Cap</h3>
              <p className="text-sm text-start text-gray-500 font-medium mt-1">Set the maximum points students can redeem in a 24-hour cycle.</p>
              <button
                onClick={() => setShowConfigModal(false)}
                className="absolute top-6 right-6 p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-all"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-10 space-y-8">
              <div className="space-y-4">
                <label className="text-xs font-medium text-gray-500 pl-1">New Redemption Point</label>
                <div className="relative group">
                  <input
                    type="text"
                    inputMode="numeric"
                    placeholder="Ex: 1000"
                    required
                    className="w-full pl-6 pr-4 py-3 bg-gray-50/30 border border-gray-200 rounded-2xl focus:ring-4 focus:ring-[#004f6b]/10 focus:border-[#004f6b] outline-none transition-all font-bold text-2xl text-[#004f6b]"
                    value={redeempoint}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "" || (/^\d+$/.test(value) && parseInt(value, 10) > 0)) {
                        setRedeempoint(value);
                      }
                    }}
                  />
                  <div className="absolute inset-y-0 right-6 flex items-center pointer-events-none">
                    <span className="text-xs font-medium text-gray-300">Points Limit</span>
                  </div>
                </div>
                <div className="bg-amber-50 rounded-xl p-3 border border-amber-100 flex items-start gap-3">
                  <svg className="w-5 h-5 text-amber-500 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
                  <p className="text-xs font-medium text-amber-700 leading-relaxed">Crucial: This value will override all current user-level caps globally upon the next synchronization cycle.</p>
                </div>
              </div>

              {message && (
                <div className="bg-green-50 text-green-700 px-6 py-4 rounded-xl border border-green-100 text-sm font-semibold flex items-center gap-3 animate-fadeIn">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" /></svg>
                  {message}
                </div>
              )}

              <div className="flex gap-4">
                <button
                  type="button"
                  onClick={() => setShowConfigModal(false)}
                  className="flex-1 py-4 border border-gray-200 text-gray-500 rounded-2xl font-semibold text-sm transition-all hover:bg-gray-50 active:scale-95"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`flex-[2] py-4 bg-[#004f6b] hover:bg-[#003e54] text-white rounded-2xl font-semibold text-sm transition-all  flex items-center justify-center gap-4 active:scale-95 ${isSubmitting ? 'opacity-70' : ''}`}
                >
                  {isSubmitting ? 'Authorizing...' : 'Apply New Cap'}
                  {!isSubmitting && (
                    <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
          @keyframes zoomIn {
              from { opacity: 0; transform: scale(0.95); }
              to { opacity: 1; transform: scale(1); }
          }
          .animate-zoomIn {
              animation: zoomIn 0.3s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          }
      `}</style>
    </div>
  );
};

export default DailyRedeemption;
